"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledMailDialogRenderer = exports.DASHBOARD_TITLE_MAX_LENGTH = exports.PLATFORM_DATE_FORMAT = void 0;
var constants_1 = require("./constants");
Object.defineProperty(exports, "PLATFORM_DATE_FORMAT", { enumerable: true, get: function () { return constants_1.PLATFORM_DATE_FORMAT; } });
Object.defineProperty(exports, "DASHBOARD_TITLE_MAX_LENGTH", { enumerable: true, get: function () { return constants_1.DASHBOARD_TITLE_MAX_LENGTH; } });
// To support gdc-dashboards
var ScheduledMailDialogRenderer_1 = require("./ScheduledMailDialog/ScheduledMailDialogRenderer");
Object.defineProperty(exports, "ScheduledMailDialogRenderer", { enumerable: true, get: function () { return ScheduledMailDialogRenderer_1.ScheduledMailDialogRenderer; } });
//# sourceMappingURL=index.js.map